// `chrome-extension/services/ats-label/ats-label.ts` — the customer-facing name of the tenant's
// ATS, for DISPLAY ONLY.
//
// ⚠️ TWO NAMES, AND ONLY ONE OF THEM IS AN IDENTITY. `atsName` is the ATS type's display name and
// every rule in this port keys on it — the logo tables, the copy tables (`candidateListCopy`,
// `atsNoteCopy`, `exportTitle`), the Bullhorn/JobDiva/Mercury branches. `atsLabel` is what the
// screen SAYS: the same string, unless the tenant has `EXTENSION_OVERRIDE_ATS_LABEL` on, in which
// case it is the tenant's configured `extensionAtsLabel`, or "ATS" (careero's
// `ExtensionAtsLabelService`). Comparing a label against an ATS type, or looking one up in a
// table, breaks every rule for exactly the tenants that asked for a label.

/** The two view-model fields the label is computed from. */
export interface AtsLabelSource {
  atsName?: string | null | undefined
  /** Absent from an older server's view model — hence the fallback. */
  atsLabel?: string | null | undefined
}

/**
 * `getAtsLabel($window)` — `careero.atsLabel || careero.atsName`.
 *
 * `||`, not `??`: an EMPTY label falls back too, as upstream's does. Undefined when neither is set,
 * which is what every caller here already renders for a missing `atsName`.
 */
export function getAtsLabel(model: AtsLabelSource | null | undefined): string | undefined {
  const label = model?.atsLabel || model?.atsName
  return label || undefined
}

/** `getAtsLabelArticle` — "an ATS company" / "a Salesforce company". A vowel-letter heuristic, upstream's. */
export function getAtsLabelArticle(atsLabel: string | null | undefined): 'a' | 'an' {
  return /^[aeiou]/i.test(atsLabel ?? '') ? 'an' : 'a'
}
